import { Component, OnInit } from "@angular/core";
import { StandardService } from "../services/standard.service";
import { StandardListType } from "../core/constant";

@Component({
  selector: "app-taking-effect-soon",
  templateUrl: "./taking-effect-soon.component.html",
  styleUrls: ["./taking-effect-soon.component.scss"],
})
export class TakingEffectSoonComponent implements OnInit {
  loading: boolean = false;
  upcomingStandards: any[] = [];

  // Same display names already used by the standards-search tabs for
  // standardTypeId (1-8).
  private standardTypeNames: { [id: number]: string } = {
    1: "Global Approved Solution",
    2: "Market Best Practices",
    3: "Market Standard",
    4: "Building Standard",
    5: "Global Equipment Standard",
    6: "Local Equipment Standard",
    7: "BU Standard",
    8: "Operations Standard",
  };

  // standardTypeId -> the matching "New <Type> Standard" icon asset. Types
  // without a dedicated icon (Global Approved Solution, Market Best
  // Practices, Local Standard, BU Standard) fall back to the building icon.
  private typeIconMap: { [id: number]: string } = {
    4: "/assets/images/Property 1=New Building Standard.svg",
    5: "/assets/images/Property 1=New Equipment Standard.svg",
    6: "/assets/images/Property 1=New Equipment Standard.svg",
    8: "/assets/images/Property 1=New Operations Standard.svg",
  };

  constructor(private standardService: StandardService) {}

  // Only standards taking effect within this many days are shown - this
  // widget is meant to surface what's coming up soon, not every upcoming
  // standard regardless of how far out it is.
  private readonly daysWindow = 30;

  ngOnInit(): void {
    this.loading = true;
    this.standardService
      .getAllStandards(0, 50, StandardListType.Upcoming, [], null, "")
      .subscribe(
        (data: any) => {
          this.upcomingStandards = (data?.standardDetailList || [])
            .map((standard: any) => {
              const effectiveDate = this.getEarliestFutureDate(standard);
              return {
                id: standard.id,
                title: standard.title,
                description:
                  standard.description?.length <= 100
                    ? standard.description
                    : standard.description?.substring(0, 100) + "...",
                effectiveDate: effectiveDate,
                daysUntilEffect: this.getDaysUntil(effectiveDate),
                standardTypeName:
                  this.standardTypeNames[standard.standardTypeId] || "Standard",
                icon:
                  this.typeIconMap[standard.standardTypeId] ||
                  "/assets/images/Property 1=New Building Standard.svg",
                redirectUrl: "/view-upcoming-standard-detail/" + standard.id,
              };
            })
            .filter(
              (record) =>
                record.daysUntilEffect !== null &&
                record.daysUntilEffect <= this.daysWindow,
            )
            .sort((a, b) => a.daysUntilEffect - b.daysUntilEffect);
          this.loading = false;
        },
        () => {
          this.loading = false;
        },
      );
  }

  // Upcoming standards always have at least one future date (that's what
  // makes them "upcoming") - show whichever one is soonest.
  private getEarliestFutureDate(standard: any): Date | null {
    const now = new Date();
    const dates = [standard.effectiveFrom, standard.newRestaurantsEffectiveFrom]
      .map((d: string) => (d ? new Date(d) : null))
      .filter((d: Date | null) => d && d > now) as Date[];
    if (!dates.length) return null;
    return new Date(Math.min(...dates.map((d) => d.getTime())));
  }

  private getDaysUntil(date: Date | null): number | null {
    if (!date) return null;
    const now = new Date();
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.max(
      0,
      Math.ceil(
        (new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() -
          new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()) /
          msPerDay,
      ),
    );
  }
}
